import { MantineSize, MantineTheme, PinInputProps, rem } from '@mantine/core';

export const DefaultPinInputProps = {
  size: 'xl' as MantineSize,
  radius: 'xs'
};

interface PinInputSizeProps {
  height: number;
}

export const pinInputSizes: Partial<Record<MantineSize, PinInputSizeProps>> = {
  xs: {
    height: 30
  },
  sm: {
    height: 36
  },
  md: {
    height: 42
  },
  lg: {
    height: 50
  },
  xl: {
    height: 60
  }
};

export const PinInputVarsResolver = (
  theme: MantineTheme,
  props: PinInputProps
): any => {
  if (props.size === 'xs') {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.xs?.height)
      }
    };
  } else if (props.size === 'sm') {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.sm?.height)
      }
    };
  } else if (props.size === 'md') {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.md?.height)
      }
    };
  } else if (props.size === 'lg') {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.lg?.height)
      }
    };
  } else if (props.size === 'xl') {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.xl?.height)
      }
    };
  } else {
    return {
      input: {
        '--input-size': rem(pinInputSizes?.md?.height)
      }
    };
  }
};
